<p-button #menuButton [text]="true" [pt]="pt()" (onClick)="menu.toggle($event)" data-cy="user-menu-button">
    <p-avatar shape="circle" data-cy="user-avatar">
        <span class="c-primary-black fw-500">{{ avatarLabel() }}</span>
    </p-avatar>
</p-button>
<p-menu #menu [model]="menuOptions()" [popup]="true" [appendTo]="menuButton" [pt]="menuPt" data-cy="user-menu">
    <ng-template #start>
        <section class="flex flex-col" data-cy="user-info-section">
            <span class="text-l c-primary-grey" data-cy="user-name">{{ userName() }}</span>
            <span class="text-s c-secondary-grey letter-spacing--none" data-cy="user-email">
                {{ userEmail() }}
            </span>
        </section>
        <p-divider [pt]="dividerPt"></p-divider>
    </ng-template>
    <ng-template #submenuheader let-group>
        <span class="user-menu__group" data-cy="menu-group-header">{{ group.label }}</span>
    </ng-template>
    <ng-template #item let-item>
        <a class="user-menu__item" [class]="item.data?.styleClass" data-cy="menu-item">
            <i class="icon"></i>
            <span>{{ item.label }}</span>
        </a>
    </ng-template>
    <ng-template #end>
        <p-divider></p-divider>
        <button class="btn__logout user-menu__item" (click)="handleLogout()" data-cy="logout-button">Logout</button>
    </ng-template>
</p-menu>
